// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V5OND","importantInfo":"styles_importantInfo__Qze6a"};